(function ($) {
    var currentPresentationPage = 1;
    var presentationAjax        = null;
    var ajaxTimeout     = null;

    var loadPresentations = function () {
        var template  = $('#js-presentation-item').html();
        var $loader   = $('.js-presentation-loader');
        var $list     = $('.js-presentation-list');
        var $loadMore = $('.js-presentation-next-page');

        Mustache.parse(template);

        var data = {
            page: currentPresentationPage,
            nonce: rissb_var.nonces.get_presentations,
        };

        if (window.matchMedia('(max-width: 768px)').matches) {
            data.filters = $('.filter-mobile .js-presentation-filters :input').serialize();
        } else {
            data.filters = $('.filter-desktop .js-presentation-filters :input').serialize();
        }

        if (data.page == 1) {
            $loader.removeClass('d-none');
            $list.empty();
        }

        if (presentationAjax) {
            presentationAjax.abort();
        }

        presentationAjax = $.post('/api/presentations', data, function (res) {
            var rendered   = Mustache.render(template, res.data);

            $loader.addClass('d-none');

            if (data.page == 1) {
                $list.html(rendered);
            } else {
                $list.append(rendered);
            }

            $(rendered).imagesLoaded(function() {
                $.fn.matchHeight._apply('[data-mh="card-presentation"]');
            });

            $loadMore.closest('div').toggleClass('d-none', res.data.pagination.total <= res.data.pagination.current);
        }).always(function () {
            $loadMore.text($loadMore.data('text-original'));
        });
    };

    $(document).ready(function () {
        if ($('body').hasClass('post-type-archive-presentation')) {
            RISSB.fn.clearDropdownFilter(function () {
                currentPresentationPage = 1;
                loadPresentations();
            });

            if ($('.js-presentation-list').length) {
                currentPresentationPage = 1;
                loadPresentations();
            }

            $('.js-presentation-filters').find('.js-presentation-search').on('keyup input', function () {
                currentPresentationPage = 1;

                clearTimeout(ajaxTimeout);
                ajaxTimeout = setTimeout(loadPresentations, 500);
            });

            $('.js-update-filter').on('click', function () {
                var $this = $(this);
                currentPresentationPage = 1;

                RISSB.fn.updateQSParams('presentation_categories[]', $this.closest('.js-presentation-filters').find('input[name="presentation_categories[]"]:checked').map(function () {
                    return $(this).val();
                }).get(), true);

                loadPresentations();
                $this.closest('.dropdown-menu').removeClass('show');
            });

            $('.js-presentation-next-page').on('click', function (e) {
                e.preventDefault();

                var $this = $(this);
                currentPresentationPage = currentPresentationPage + 1;

                $this.html('<i class="fas fa-spinner fa-spin fa-fw"></i> ' + $this.data('text-progress'));
                loadPresentations();
            });

            $('.js-dropdown-sort').on('click', '.dropdown-item', function (e) {
                e.preventDefault();

                var $this = $(this);
                currentPresentationPage = 1;

                $('[name="orderby"]').val($this.data('orderby'));
                $('[name="order"]').val($this.data('order'));
                $('.js-order-type').text($this.text());

                loadPresentations();
            });
        }
    });
})(jQuery);

